/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { values } from '../../../../utils/lodash-utils'

import Selection from './Selection'
import {
  fetchMetricTypes,
  selectAllMetricTypes,
} from '../../api/metricTypes/actions'

import { setColumns, } from '../columns/actions'


const mapStateToProps = (state, props) => {
  const types = values(state.types.groups)
  return {
    types,
    hide: state.selection.hide,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    getMetricTypes,
  } = ownProps

  return {
    fetchMetricTypes: (contextValue) => {
      return dispatch(fetchMetricTypes(() => getMetricTypes(contextValue)))
    },
    onSelectAll: (contextValue, selected) => {
      return dispatch(selectAllMetricTypes(contextValue, selected))
    },
    setColumns: (n) => dispatch(setColumns(n)),
  }
}


class SelectionRedux extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.contextValue !== nextProps.contextValue) {
      this.props.fetchMetricTypes(nextProps.contextValue)
    }
  }

  componentWillMount() {
    this.props.fetchMetricTypes(this.props.contextValue)
  }

  render() {
    return <Selection {...this.props} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionRedux)
